import { Action } from '@ngrx/store';
import {LicenseMgtDetail} from '../license-mgt.model';

export enum LicenseDetailActionTypes {
  GetLicenseDetails = '[LicenseDetail] Get LicenseDetails',
  LoadLicenseDetails = '[LicenseDetail] Load LicenseDetails',
  GetLicenseDetailsFail = '[LicenseDetail] Get LicenseDetails Fail'
}

export class GetLicenseDetails implements Action {
  readonly type = LicenseDetailActionTypes.GetLicenseDetails;
  constructor(public payload: number) {}
}

export class LoadLicenseDetails implements Action {
  readonly type = LicenseDetailActionTypes.LoadLicenseDetails;
  constructor(public payload: LicenseMgtDetail) {}
}

export class GetLicenseDetailsFail implements Action {
  readonly type = LicenseDetailActionTypes.GetLicenseDetailsFail;
}

export type LicenseDetailActions =
  GetLicenseDetails
  | LoadLicenseDetails
  | GetLicenseDetailsFail;
